<template>
  <v-btn
    v-if="$abilities.includes('update shipments')"
    color="primary"
    small
    :disabled="!$route.query.batch || selectedShipments.length === 0"
    @click="removeFromBatch"
  >
    Remove from batch
    <v-icon dark right> mdi-delete </v-icon>
  </v-btn>
</template>
<script>
export default {
  name: "BatchRemoveButton",
  data() {
    return {
      batch: {},
      selectedShipments: [],
    };
  },
  mounted() {
    this.$bus.$on("selectedShipments", (value) => {
      this.selectedShipments = value;
    });
  },
  methods: {
    confirmNoShippedShipments: function () {
      // Check if any selected shipments have already shipped
      let shippedShipments = this.selectedShipments.filter((shipment) => {
        return shipment.trackingId;
      });
      if (shippedShipments.length > 0) {
        const confirmPromise = this.$confirm(
          `Remove ${shippedShipments.length} already shipped shipments from batch? <br><br> To reset selections <a id="reset-selections-link" style="cursor: pointer; text-decoration: underline;">click here</a>`,
          {
            title: "Warning",
            buttonTrueText: "Remove",
            buttonFalseText: "Cancel",
          }
        );

        // Add click handler for the reset link after dialog is rendered
        this.$nextTick(() => {
          const resetLink = document.getElementById("reset-selections-link");
          if (resetLink) {
            resetLink.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.$bus.$emit("clearSelectedShipments");
              this.$bus.$emit("refreshShipments");
              // Close the dialog
              const dialogs = document.querySelectorAll(".v-dialog");
              dialogs.forEach((dialog) => {
                const closeBtn = dialog.querySelector("button");
                if (closeBtn) closeBtn.click();
              });
            });
          }
        });

        return confirmPromise;
      }
      return Promise.resolve(true);
    },
    removeFromBatch: async function () {
      if (await this.confirmNoShippedShipments()) {
        this.$models.Batch.find(this.$route.query.batch, {
          include: "shipments",
        })
          .then((response) => {
            if (response.data) {
              this.batch = response.data;

              let shipmentSubset = this.batch.shipments.filter(
                (currentShipment) => {
                  return !this.selectedShipments.some((removedShipment) => {
                    return currentShipment.id === removedShipment.id;
                  });
                }
              );

              this.$models.Batch.update(
                this.$route.query.batch,
                { shipments: shipmentSubset },
                { include: "shipments" }
              )
                .then(() => {
                  this.$bus.$emit(
                    "removeFromBatch",
                    this.$route.query.batch,
                    shipmentSubset
                  );
                  this.$router.push({ name: "Home" });
                })
                .catch((e) => this.$bus.$emit("Error", e));
            }
          })
          .catch((e) => this.$bus.$emit("Error", e));
      }
    },
  },
  getBatch: function () {
    this.$models.Batch.all({ include: "shipments" })
      .then((response) => {
        this.batches = response.data;

        if (this.$route.query.batchId) {
          this.openBatch(
            this.batches.find((batch) => batch.id === this.$route.query.batchId)
          );
        }
      })
      .catch((e) => this.$bus.$emit("Error", e));
  },
};
</script>
